import { createSelector } from 'reselect';
import { sortBy } from 'lodash';

// handy debugging selector that allows you to run a function in the middle of a
// selector chain without affecting the output
export const tap = func => value => {
  func(value);
  return value;
};

export default options => {
  const { name } = options;

  const byId = state => state[name].byId;
  const initialLoadComplete = state => !!state[name].lastFetch;
  const loading = state => state[name].loading;
  const values = createSelector(byId, allObjectsById => {
    const result = Object.values(allObjectsById);
    const { defaultSortBy } = options;
    return defaultSortBy ? sortBy(result, defaultSortBy) : result;
  });
  const paginationStatus = state => state[name].paginationStatus;

  const paginationInfo = createSelector(paginationStatus, loading, (status, isLoading) => {
    const { total, pagesLoaded, perPage } = status;

    const estimateLoaded = Math.min((pagesLoaded.length || 0) * perPage, total);
    let percentage = (estimateLoaded * 100) / total;

    return { total, estimateLoaded, percentage, loading: isLoading };
  });

  const persistedValues = createSelector(byId, allObjectsById =>
    Object.values(allObjectsById).filter(value => !value.transient)
  );
  const error = state => state[name].error;

  return {
    byId,
    initialLoadComplete,
    values,
    persistedValues,
    paginationInfo,
    error,
    loading
  };
};
